export const GET_CONTRACT_PARTNER_REQUEST_SENT = 'GET_CONTRACT_PARTNER_REQUEST_SENT';
export const GET_CONTRACT_PARTNER_REQUEST_SUCCEEDED = 'GET_CONTRACT_PARTNER_REQUEST_SUCCEEDED';
export const GET_CONTRACT_PARTNER_REQUEST_FAILED = 'GET_CONTRACT_PARTNER_REQUEST_FAILED';
export const GET_CONTRACT_PARTNER_REQUEST = 'GET_CONTRACT_PARTNER_REQUEST';

export const STORE_CONTRACT_PARTNERS = 'STORE_CONTRACT_PARTNERS';
